import apiPayPlan from './functions/apiPayPlan';

const plan = {
  payPlan: apiPayPlan
};

export default plan;
